<template>
  <div>
    <section class="jumbotron jumbotron-fluid bg-cover mb-0 bg-img-height-l" :style="{ backgroundImage: 'url(' + swiperBg + ')' }">
      <div class="container">
        <div class="row">
          <div class="col-md-5 d-none d-md-block">
            <div class="d-flex flex-column align-items-start">
              <p class="h3 text-primary mt-5 font-size-l">
                {{ $t("home.swiperTextFormat") }}
              </p>
              <h1 class="text-primary font-weight-bold pt-2 font-size-xl">
                {{ $t("home.swiperTextFormat2") }}
                <br />
                {{ $t("home.swiperTextFormat3") }}
              </h1>
              <router-link class="btn btn-outline-primary mt-4" to="/wines">{{ $t("home.swiperBtnFormat") }}</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="d-md-none mt-3 pt-2">
        <div class="d-flex justify-content-center">
          <section class="p-4 bg-alpha-dark d-flex flex-column align-items-start">
            <p class="text-primary font-size-l text-shadow">{{ $t("home.swiperTextFormat") }}！</p>
            <h1 class="text-primary font-weight-bold pt-2 font-size-xl text-shadow">
              {{ $t("home.swiperTextFormat2") }}
              <br />
              {{ $t("home.swiperTextFormat3") }}
            </h1>
            <router-link class="btn btn-outline-primary mt-4 box-shadow" to="/products">
              {{ $t("home.swiperBtnFormat") }}
            </router-link>
          </section>
        </div>
      </div>
    </section>
    <div class="bg-more pb-3">
      <section class="container text-more pt-4">
        <div class="row">
          <div class="col-md-7 pr-0 d-none d-md-block">
            <div class="bg-cover-left bg-img-height-l-plus" :style="{ backgroundImage: 'url(' + Bg1 + ')' }"></div>
          </div>
          <div class="col-md-5 d-flex flex-column align-items-center justify-content-center">
            <p class="h2 text-more text-center font-weight-bold d-md-none d-lg-block mt-3 mt-md-0">
              {{ $t("home.contactModel.titleFormat") }}
              <br />
              <span class="h1 font-RussoOne text-more line-height-m">
                LeapflyWine
              </span>
            </p>
            <p>
              {{ $t("home.contactModel.contentFormat") }}
            </p>
            <p>
              {{ $t("home.contactModel.contentFormat2") }}
            </p>
            <router-link class="btn btn-primary mt-3" to="/contact"> {{ $t("home.contactModel.btnFormat") }}</router-link>
          </div>
        </div>
      </section>
      <section class="container ">
        <div class="form-row mb-4 bg-more">
          <div class="col-md-4 py-5">
            <div class="h-100 d-flex flex-column justify-content-center">
              <p class="h3 font-weight-bold text-more text-center px-3 font-size-m-plus">
                {{$t('home.teamModel.titleFormat')}}
              </p>
              <p class="text-more px-3">
                {{$t('home.teamModel.contentFormat')}}
              </p>
            </div>
          </div>
          <div class="col-md-8">
            <div class="bg-cover d-md-none bg-img-height-s" :style="{ backgroundImage: 'url(' + homebg1 + ')' }"></div>
            <div class="bg-cover h-100 d-none d-md-block" :style="{ backgroundImage: 'url(' + homebg1 + ')' }"></div>
          </div>
        </div>
        <div class="form-row mt-gutter-s">
          <div class="col-md-8 d-none d-md-block">
            <div class="bg-cover h-100" :style="{ backgroundImage: 'url(' + homebg2 + ')' }"></div>
            <div class="bg-cover d-md-none bg-img-height-s" :style="{ backgroundImage: 'url(' + homebg2 + ')' }"></div>
          </div>
          <div class="col-md-4 d-none d-md-block">
            <div class="h-100 d-flex flex-column justify-content-center">
              <p class="h3 font-weight-bold text-more text-center pt-3 px-3 font-size-m-plus">
                {{$t('home.exclusiveModel.titleFormat')}}
              </p>
              <p class="text-more px-3">
                {{$t('home.exclusiveModel.contentFormat')}}
              </p>
              <p class="text-more px-3">
                {{$t('home.exclusiveModel.contentFormat2')}}
              </p>
            </div>
          </div>
          <div class="col-md-4 d-md-none">
            <div class="bg-gray h-100 d-flex flex-column justify-content-center">
              <p class="h3 font-weight-bold text-more text-center pt-3 px-3 font-size-m-plus">
                {{$t('home.exclusiveModel.titleFormat')}}
              </p>
              <p class="text-more px-3">
                {{$t('home.exclusiveModel.contentFormat')}}
              </p>
              <p class="text-more px-3">
                {{$t('home.exclusiveModel.contentFormat2')}}
              </p>
            </div>
          </div>
          <div class="col-md-8 d-md-none">
            <div class="bg-cover bg-img-height-s" :style="{ backgroundImage: 'url(' + homebg2 + ')' }"></div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
/* global $ */
import swiperBg from "@/assets/img/swiper-bg.png";
import Bg1 from "@/assets/img/bg-1.png";
import homebg1 from "@/assets/img/home-bg-1.png";
import homebg2 from "@/assets/img/home-bg-2.png";
export default {
  data() {
    return {
      swiperBg,
      Bg1,
      homebg1,
      homebg2,
    };
  },
  methods: {},
};
</script>
